import React, { useState } from 'react';
import { sylvettePhoto } from './sylvettePhotos';

export default function SylvettePhotoArt({ front, back, view = 'front', ribbonFabric, decorative, className = '', label }) {
  const photo = sylvettePhoto(view === 'back' ? back : front, ribbonFabric, view);
  const [loaded, setLoaded] = useState('');
  const [failed, setFailed] = useState('');
  return (
    <div className={`bookmark-art sylvette-photo ${className}`}
      role={decorative ? undefined : 'img'} aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : `${label ? `${label}. ` : ''}${photo.description}${photo.exact ? '' : ' · combinaison non représentée'}`}
      aria-busy={loaded !== photo.src && failed !== photo.src}>
      <img key={photo.src} src={photo.src} alt="" width={photo.width} height={photo.height} draggable="false"
        onLoad={() => setLoaded(photo.src)} onError={() => setFailed(photo.src)} />
      {failed === photo.src && <span className="bookmark-art-error">La photo n’a pas pu être chargée.</span>}
    </div>
  );
}
